module.exports = __webpack_public_path__ + "account/img/158.efd98c74.png";